import { render, staticRenderFns } from "./Formula.vue?vue&type=template&id=50e8d9e2&scoped=true"
import script from "./Formula.vue?vue&type=script&lang=js"
export * from "./Formula.vue?vue&type=script&lang=js"
import style0 from "./Formula.vue?vue&type=style&index=0&id=50e8d9e2&prod&lang=scss&scoped=true"
import style1 from "./Formula.vue?vue&type=style&index=1&id=50e8d9e2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50e8d9e2",
  null
  
)

export default component.exports